import { Component, HostListener } from '@angular/core';

import * as Pages from './../../../../support/pages';
import { MenuService } from '../../../../menu/services/menu.service';

@Component({
    selector: 'chassis-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent {

    public menu;

    public css;

    public appMenu = false;

    private cssAnimation;
    private css3d;
    private sidebarWidth;
    private sidebarWidthCondensed;

    constructor(protected menuService: MenuService) {

        this.menu = menuService.get('sidebar');

        this.css          = {};
        this.cssAnimation = true;
        this.css3d        = true;

        this.sidebarWidth          = 280;
        this.sidebarWidthCondensed = 280 - 70;

    }

    public togglePin(toggle: string | null = null) {

        const body = document.querySelector('body');

        if (toggle === 'hide') {
            body.classList.remove('menu-pin');
        } else if (toggle === 'show') {
            body.classList.add('menu-pin');
        } else {
            body.classList.toggle('menu-pin');
        }

    }

    public toggleAppMenu() {

        this.appMenu = !this.appMenu;

    }

    @HostListener('mouseenter')
    onMouseEnter() {

        const body = document.querySelector('body');

        const sideBarWidthCondensed = body.classList.contains('rtl') ? -this.sidebarWidthCondensed : this.sidebarWidthCondensed;

        const transform = (this.css3d === true ? 'translate3d(' + sideBarWidthCondensed + 'px, 0,0)' : 'translate(' + sideBarWidthCondensed + 'px, 0)');

        this.css = {'transform': transform};

        if (Pages.isVisibleSm() || Pages.isVisibleXs()) {
            return false;
        }

        // if (document.querySelector('.close-sidebar') && document.querySelector('.close-sidebar').getAttribute('data-clicked')) {
        //     return;
        // }

        if (body.classList.contains('menu-pin')) {
            return;
        }

        body.classList.add('sidebar-visible');

    }

    @HostListener('mouseleave')
    onMouseLeave() {

        const body = document.querySelector('body');

        body.classList.remove('sidebar-visible');

        const transform = (this.css3d === true ? 'translate3d(0px, 0,0)' : 'translate(0px, 0)');

        this.css = {'transform': transform};

        if (Pages.isVisibleSm() || Pages.isVisibleXs()) {
            return false;
        }

        if (document.querySelector('.sidebar-overlay-slide').classList.contains('show')) {
            document.querySelector('.sidebar-overlay-slide').classList.remove('show');
            document.querySelector('[data-pages-toggle]').classList.remove('active');
        }

        if (body.classList.contains('menu-pin')) {
            return;
        }

        // setTimeout(function () {
        //     if (body.querySelector('.close-sidebar')) {
        //         body.querySelector('.close-sidebar').setAttribute('data-clicked', 'false');
        //     }
        // }, 100);

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials/sidebar/sidebar.component.ts